import Flows from './Flows';

export const PAGE_FLOWS = '/flows';

export default Flows;
